module.exports = __webpack_public_path__ + "static/ENSPRYNG_logo-766a1c689fb33ae4c7cd831d1d35a4b1.svg";